module.exports = __webpack_public_path__ + "static/play-e512a7310278e422fe3518c60387d7a7.png";